/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2025 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {Component} from 'react';
import {validated} from 'react-custom-validation';
import {ButtonToolbar, Col, Row} from 'react-bootstrap';
import Helmet from 'react-helmet';
import $ from 'jquery';

import Input from '@corero/ssp-ui-components/components/form/input/Input';
import SimpleButton from '@corero/ssp-ui-components/components/buttons/SimpleButton/SimpleButton';
import BlueButton from '@corero/ssp-ui-components/components/buttons/BlueButton/BlueButton';

import validationRules from '@corero/ssp-ui-components/core/validation';
import withRouter from '@corero/ssp-ui-components/utils/withRouter';
import {store} from '@corero/ssp-ui-components/stores/AuthStore';
import sharedConfig from '@corero/ssp-ui-components/core/sharedConfig';

import './forgotPassword.scss';

import {actions as themeActions, store as themeStore} from "@corero/ssp-ui-components/stores/AppConfigStore"


class ForgotPassword2 extends Component {
    constructor(props) {
        super(props);
        this.state = {fields: {newPassword: "", confirmPassword: ""}, ready: false, disableSubmit: false};
    }

    componentDidMount() {
        $("body").addClass("forgot-password-page");
        $(".forgot-password-page").css("background-image", "url(" + sharedConfig.apis.theme + "/backgroundImage)")
        themeStore.addChangeListener(this._onThemeConfigChange)
        themeActions.fetchThemeConfiguration();
    }

    _onThemeConfigChange = () =>{
        this.setState({
            login_color_text : (themeStore.getThemeConfiguration()).login_color_text,
            ready: true
        })
    }

    componentWillUnmount = () => {
        $("body").removeClass("forgot-password-page");
        $('.forgot-password-page').css('background-image', '');
        themeStore.removeChangeListener(this._onThemeConfigChange)
    };

    fieldChange = (field, value) => {
        this.state.fields[field] = value; // eslint-disable-line
        this.setState({ fields: this.state.fields });
    }

    cancel = () => {
        this.props.router.navigate('/login');
    }

    submit = () => {
        this.setState({disableSubmit: true});
        store.resetPassword(this.state.fields.newPassword)
            .then(() => {
                this.cancel();
            })
            .finally(() => {
                this.setState({disableSubmit: false});
            });
    }

    render() {
        if (!this.state.ready) {
            return null;
        }
        return (
            <div className="forgot-password-container">
                <div className="forgot-password-inner-container">
                    <Helmet defer={false} title="Password Recovery"/>
                    <Row>
                        <Col sm={{ span: 6, offset: 3 }}>
                            <p style={{color: this.state.login_color_text}} className="password-info mt40">Please enter
                                your new password</p>
                        </Col>
                    </Row>

                    <Row className="mt20">
                        <Col sm={{ span: 4, offset: 4 }}>
                            <Form
                                fields={this.state.fields}
                                onCancel={this.cancel}
                                onChange={this.fieldChange}
                                onValid={this.submit}
                                disableSubmit={this.state.disableSubmit}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

class Form extends Component {
    render() {
        const {$field, $validation, onValid, onInvalid, onChange} = this.props;
        const fields = { $field, $validation, onChange, fields: this.props.fields };

        const {
            login_color_button, login_color_btn_foreground, login_color_cancel_btn,
            login_color_cancel_btn_foreground, login_color_error_text,
            login_button_border_color, login_button_border_width,
        } = themeStore.getThemeConfiguration()
        return (

            <form onSubmit={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
            }}>
                <Input errorColor={login_color_error_text} type="password" fieldSizes={{ xs:12 }} name="newPassword" placeholder="New Password" {...fields} />
                <Input errorColor={login_color_error_text} type="password" fieldSizes={{ xs:12 }} name="confirmPassword" placeholder="Confirm Password" {...fields} />
                        <ButtonToolbar>
                            <SimpleButton title="Cancel" isDisabled={this.props.disableSubmit} style={{
                                background: login_color_cancel_btn,
                                border: "none",
                                color: login_color_cancel_btn_foreground
                            }} click={(e) => {
                                e.preventDefault();
                                this.props.onCancel();
                            }}/>
                            <BlueButton title="Update Password" className="long-btn" style={{
                                background: login_color_button,
                                color: login_color_btn_foreground,
                                border: !Number.isNaN(login_button_border_width) && login_button_border_color
                                ? `${login_button_border_width}px solid ${login_button_border_color}`
                                : "none"
                            }} isDisabled={this.props.disableSubmit}/>
                        </ButtonToolbar>
            </form>
        );
    }
}
//Method for password compare
function isEqual(newPassword, confirmPassword) {
    if (newPassword !== confirmPassword) {
        return 'Passwords do not match';
    }
}
Form = validated(validationConfig)(Form);

function validationConfig(props) {

    const { newPassword, confirmPassword } = props.fields;

    return {
        fields: ['newPassword', 'confirmPassword'],

        validations: {
            newPassword: [[validationRules.required, newPassword]],
            confirmPassword: [[validationRules.required, confirmPassword], [isEqual, newPassword, confirmPassword]]
        },
    }
}

export default withRouter(ForgotPassword2);
